// @flow
import { LanguagesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    dictionary: {},
    loading: false,
    error: false,
    formSubmited: false
};

type LanguagesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { dictionary?: {} | null, loading?: boolean, +value ?: boolean };

const Languages = (state: State = INIT_STATE, action: LanguagesAction): any => {
    // console.log(action);
    switch (action.type) {
        case LanguagesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case LanguagesActionTypes.GET_DICTIONARY: {
                    return {
                        ...state,
                        dictionary: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case LanguagesActionTypes.ADD_DICTIONARY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LanguagesActionTypes.UPDATE_DICTIONARY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case LanguagesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case LanguagesActionTypes.GET_DICTIONARY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        dictionary: {},
                        loading: false,
                    };
                }
                case LanguagesActionTypes.ADD_DICTIONARY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case LanguagesActionTypes.UPDATE_DICTIONARY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case LanguagesActionTypes.GET_DICTIONARY:
            return { ...state, error: false, loading: true };
        case LanguagesActionTypes.ADD_DICTIONARY:
            return { ...state, error: false, loading: true };
        case LanguagesActionTypes.UPDATE_DICTIONARY:
            return { ...state, error: false, loading: true };
        case LanguagesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                dictionary: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Languages;
